"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1({ queryClient, notificationId, }) {
    queryClient.setQueriesData(['notificationLogData'], data => data && Object.assign(Object.assign({}, data), { pages: data.pages.map(page => (Object.assign(Object.assign({}, page), { result: page.result.map(notification => notification.id === notificationId ? Object.assign(Object.assign({}, notification), { is_click: true }) : notification) }))) }));
}
exports.default = default_1;
